<template>
  <div class="home_page">
    <Dream></Dream>
    <div class="integration">
      <div class="lef">
        <img src="http://aite.cnaite.cn/data/upload/shop/adv/06322552952890293.jpg" alt />
      </div>
      <div class="rig">
        <img src="http://aite.cnaite.cn/data/upload/shop/adv/06322553140271638.png" alt />
      </div>
    </div>
    <div class="guangg">
      <img src="http://aite.cnaite.cn/data/upload/shop/adv/06322548373901288.jpg" alt />
    </div>
    <Information></Information>
    <Operate></Operate>
    <Industry></Industry>
    <News></News>
    <!-- 国际电商 -->
    <div class="online">
      <div class="one">
        <div class="title" @click="goToCommerce(426)">
          <span>生意经</span>
        </div>
        <div class="goods" 
          v-for="item in topData"
          :key='item.id'
            @click="goToDetail(item.id,item.pid)"
        >
          <div class="lef">
            <img
              src="http://aite.cnaite.cn/data/upload/itnews/article/0/06415085154490896_list.jpeg"
              alt
            />
          </div>
          <div class="rig">
            <div class="name">{{item.title}}</div>
            <div class="xq">[详细]</div>
          </div>
        </div>
        <div class="one_list">
          <div class="list"
            v-for="item in listData"
            :key='item.id'
            @click="goToDetail(item.id,item.pid)"
          >{{item.title}}</div>
        </div>
      </div>
      <div class="one">
        <div class="title" @click="goToCommerce(425)">
          <span>企业区</span>
        </div>
        <div class="goods"
          v-for="item in twoData"
          :key='item.id'
            @click="goToDetail(item.id,item.pid)"
        >
          <div class="lef">
            <img
              src="http://aite.cnaite.cn/data/upload/itnews/article/0/06415089467135422_list.jpeg"
              alt
            />
          </div>
          <div class="rig">
            <div class="name">{{item.title}}</div>
            <div class="xq">[详细]</div>
          </div>
        </div>
        <div class="one_list">
          <div class="list"
            v-for="item in twolistData"
            :key='item.id'
            @click="goToDetail(item.id,item.pid)"
          >{{item.title}}</div>
        </div>
      </div>
      <div class="two">
        <div class="title" @click="goToCommerce(425)">
          <span>企业家专区</span>
        </div>
        <div class="two_list">
          <div class="list"
            v-for="item in riglistData"
            :key='item.id'
            @click="goToDetail(item.id,item.pid)"
          >
            <span class="lef">{{item.source}}</span>
            <span class="rig">{{item.title}}</span>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Information from "./Information";
import Dream from "./Dream";
import Operate from "./Operate";
import Industry from "./Industry";
import News from "./News";
import axios from 'axios'
import Qs from 'qs'
export default {
  data() {
    return {
      topData: [],
      listData: [],
      twoData: [],
      twolistData: [],
      riglistData: []
    }
  },
  created() {
    // 生意经
    let lefParams = {
      classid: 426,
      count: 5,
    }
    axios.post('/ajax/Archivejson.ashx', Qs.stringify(lefParams)).then((res) => {
      res.data.forEach(element => {
        element.pid = 426;
      });
      this.topData = res.data.splice(0,1);
      this.listData = res.data.splice(0,4);
      // console.log('wewrf', this.topData.imgurl)
      // if (this.topData.imgurl)
    })
    // 企业区
    let conParams = {
      classid: 427,
      count: 5,
    }
    axios.post('/ajax/Archivejson.ashx', Qs.stringify(conParams)).then((res) => {
      res.data.forEach(element => {
        element.pid = 427;
      });
      this.twoData = res.data.splice(0,1)
      this.twolistData = res.data.splice(0,4)
      // console.log('213112',res);
    })
    // 企业家专区
    let rigParams = {
      classid: 425,
      count: 11,
    }
    axios.post('/ajax/Archivejson.ashx', Qs.stringify(rigParams)).then((res) => {
      res.data.forEach(element => {
        element.pid = 425;
      });
      this.riglistData = res.data;
    })
  },
  methods:{
    goToDetail(value,pid){
      this.$router.push({path:'/sxy/detail',query:{id:value,classId:pid}})
    },
    goToCommerce(id){
      this.$router.push({path:`/sxy/commerce/${id}`});
    }
  },
  components: {
    Information,
    Dream,
    Operate,
    Industry,
    News
  }
};
</script>
<style scoped lang="scss">
.home_page {
  width: 1200px;
  height: auto;
  margin: auto;
}
.integration {
  display: flex;
  justify-content: space-between;
}
.guangg {
  margin-top: 5px;
}
.online {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  .one {
    width: 390px;
    border-right: 1px solid #dcdcdc;
    .title {
      height: 39px;
      width: 371px;
      border-bottom: 1px solid #ccc;
      span {
        color: #333333;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .goods {
      display: flex;
      margin-top: 10px;
      .lef {
        margin-right: 10px;
        img {
          width: 100px;
          height: 60px;
        }
      }
      .rig {
        .name {
          font-size: 14px;
          color: #cc3300;
          margin-bottom: 12px;
        }
        .xq {
          font-size: 12px;
          color: #2584b0;
        }
      }
    }
    .one_list {
      .list {
        color: #333;
        font-size: 14px;
        line-height: 30px;
        height: 30px;
        cursor: pointer;
      }
    }
  }
  .two {
    width: 300px;
    border-right: 1px solid #dcdcdc;
    .title {
      height: 39px;
      width: 371px;
      border-bottom: 1px solid #ccc;
      span {
        color: #333333;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .two_list {
      .list {
        display: flex;
        margin-top: 10px;
        cursor: pointer;
        .lef {
          color: #333;
          font-size: 14px;
        }
        .rig {
          font-weight: normal;
          color: #555555;
          padding-left: 5px;
          font-size: 14px;
          width: 220px;
          overflow: hidden;
          text-overflow:ellipsis; 
          white-space:nowrap; 
        }
      }
    }
  }
}
</style>